// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const AddUser = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <circle cx="13.87" cy="14.24" r="6.35" fill={fill || "none"} />
      <path
        d="M2.5,26.56c0,4.93,4.93,10.89,10.89,10.89s4.07-.76,5.68-1.89c-2.08-2.46-3.31-5.59-3.31-8.43s1.89-2.27,4.64-2.84c-6.25-1.33-17.9-.57-17.9,2.27Z"
        fill={fill || "none"}
      />
      <circle cx="30.06" cy="11.59" r="8.05" fill={fill || "none"} />
      <path
        d="M43.23,27.03c0-1.99-4.64-3.22-10.13-3.6-4.36-.28-9.28,0-12.69.76-2.75.57-4.64,1.52-4.64,2.84,0,2.84,1.23,5.97,3.31,8.43,2.27,2.75,5.49,4.83,9.19,5.21h0"
        fill="none"
      />
      <path d="M36.45,41.44v-12.86s0,12.86,0,12.86Z" fill="none" />
      <path d="M42.87,35.01h-12.86s12.86,0,12.86,0Z" fill="none" />
      <circle cx="36.45" cy="35.01" r="10" fill="none" />
    </svg>
  );
};
